import { FC } from 'react'

const Cv: FC = () => {
    return (
        <div className="cv-page">
            <div className="cv">
                <p><span> She was born in Stakhanov, Lugansk region</span></p>
                <p> <span>1980 - 1985</span> – studied at the Lviv Akademy of Arts</p>
                <p> <span>1988</span> - participating at “Expres – awant-garde” international exhibition (Moskow)</p>
                <p> <span>1995</span> - with the colleagues to create “Paradise birds” theater-studio</p>
                <p> (synthesis of costume, dance, music)</p>
                <p> <span>1995 - 2001</span> - organizing a series of theatrical performances in Italian yard, The</p>
                <p> Scientist’s Hous, The l. Kurbas’Theater, The Holl of Organ and Chamber Music (Lviv)</p>
                <p> <span>1998</span> - taking part at “The Magic Needle” (Kyiv)</p>
                <p> <span>2001</span> - participating in the international designers festival(The Lviv Opera)</p>
                <p> <span>2007</span> - participating at the joint exhibitions of painting (”Autumn Saloon” ,“Art – 11” gallery)Lviv</p>
                <p> <span>2008</span> – personal exhibition at“Art – 11” gallery, Lviv</p>
                <p> <span>2009</span> - “Green Sofa”gallery-personal exhibition, Lviv</p>
                <p> <span>2009</span> - joint exhibition in Slovakia</p>
                <p> <span>2011</span> - personal exhibition at “Coralli Gallery”, Lviv</p>
                <p> <span>2012</span> - the collective exhibitions “NU”, “Portret”(“ Coralli Gallery”)</p>
                <p> <span>2012</span> - joint exhibition of Abstract Art(Kyiv)</p>
                <p> <span>2012</span> - personal exhibition at Kyiv Folk Art Exhibition House</p>
                <p> <span>2012</span> - diplomant of the Ukrainian Art Week</p>
                <p> <span>2012</span> - taking part at the Pan-Ukrainian exhibition”Woman portrait”;</p>
                <p> <span>2013</span> - collective exhibitions, Lviv,Kyiv;</p>
                <p> <span>2013</span> - partaking at CzechArtWeek;</p>
                <p> <span>2014</span> - joined an exhibitions in Kyiv, Lviv;</p>
                <p> <span>2014</span> - collective exhibition at “Art-e-fakt galery”, Lviv;</p>
                <p> <span>2014</span> - personal exhibition at “Arka”gallery, Kyiv;</p>
                <p> <span>2015</span> - personal exhibition at”Art gallery of madam Palmgren”, Lviv;</p>
                <p> <span>2016</span> - taking part at the exhibition”Male nude” The Centre of Contemporery Art”White World”, Kyiv;</p>
                <p> <span>2016</span> - personal exhibition at ”Art gallery of madam Palmgren”, Lviv;</p>
                <p> <span>2017</span> - participating the “Art Cube Project” at the international Alfa Jazz Fest, Lviv;</p>
                <p> <span>2017</span> - took part in the cultural and artistic project “Under the Pinzel’s star”</p>
                <p> <span>2018</span> - taking part in the collective exhibition in the Art Gallery of Madam Palmgren, Lviv;</p>
                <p> <span>2018</span> - participating the “Art Cube Project” at the international Alfa Jazz Fest, Lviv.</p>
                <p> <span>2018</span> - personal exhibition at "Art gallery of madam Palmgren", Lviv</p>
                <p> <span>2019</span> - diploma of the exibition at Salon Art Shopping in "Carrousel du Louvre" (Paris, France)</p>
                <p> <span>2020</span> - exhibition at the Sonia MOnti Gallery.(Paris, France)</p>
                <p> <span>2020</span> - participating the Artbox. Project(Barcelona)</p>
                <p> <span>2020</span> - partaking at the Artbox. Project(Barcelona)</p>
                <p> <span>2021</span> - participating the Artbox. Project World 1.0</p>
                <p> <span>2021</span> - participating at the joint exhibitions of plainting("Authmn Saloon") Lviv</p>
                <p> <span>2021–2024</span> — Participant in the Lviv Autumn and Spring Salons</p>
                <p> <span>2024</span> — Participant in ITSLIQUID International Art Fair, Venice, Italy (Palazzo Albrizzi-Capello)</p>
                <p> <span>2024</span> — Group exhibition, Banderol Gallery, Lviv, Ukraine</p>
                <p> <span>2025</span> — Participant in the exhibition “The Naked Truth”, Banderol Gallery, Lviv, Ukraine</p>
                <p> <span>2025</span> - Solo exhibition, Madame Palmgren Gallery, Lviv, Ukraine</p> 
                <p> <span>Now</span> - she lives and works in Lviv</p>
                <br />
                <p> <span>Nowadays, you can find her pictures in some private collections in USA, Russia, Poland, Canada and Italy.</span></p>
                <br />
            </div>

        </div>
    )
}

export default Cv
